import React from "react";
import connectProps from "fantastic/lib/connectProps";
import styles from "fantastic/components/hoc/styles";
import { compose } from "redux";

const Unsubscrible = ({contents, label, style, css_link_color}) => {

  const linkStyle = {
    color: css_link_color
  }

  return (
    <div style={style}>
      {contents} <a style={linkStyle}>{label || i18n.t('unsubscription_label') }</a>
    </div>
  )
};

export default compose(
  styles("background", "padding", "text-align", "font", "color")
)(Unsubscrible);
